export default __webpack_public_path__ + "static/media/slagter-påklædning-sikkerhedsudstyr.04089fbb.jpg";